import { makeRequest } from '../../../../lib/api';
import { ExecutorsRequest, AddExecutorsRequest } from '../../api/executorsApi';

const ORDER_EXECUTORS_PATH_V2 = '/v1/order_executors';

const executorsController = {
  getOrderExecutors: (request: ExecutorsRequest): Promise<any> => {
    return makeRequest('get', `${ ORDER_EXECUTORS_PATH_V2 }?officeId=${ request.officeId }&orderId=${ request.orderId }`);
  },

  addOrderExecutors: (request: AddExecutorsRequest): Promise<any> => {
    return makeRequest('post', `${ ORDER_EXECUTORS_PATH_V2 }`, request);
  },

  deleteOrderExecutors: (id: string): Promise<any> => {
    return makeRequest('delete', `${ ORDER_EXECUTORS_PATH_V2 }/${ id }`);
  },
};

export { executorsController };
